// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1fV2o","productName":"Table_productName__2rTa6"};